import React from 'react';
import { Stack, Tooltip, IconButton } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { useHistory, useLocation } from 'react-router-dom';

interface Props {
  id: string;
}

export const ActionsCell = ({ id }: Props) => {
  const history = useHistory();
  const { pathname, search } = useLocation();

  const handleOpen = () => {
    const params = new URLSearchParams(search);
    params.set('eventId', id);
    history.push({ pathname, search: params.toString() });
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <Tooltip title="Open event">
        <IconButton color="primary" size="small" onClick={handleOpen}>
          <Visibility fontSize="small" color="primary" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
